import { render, staticRenderFns } from "./Choices.vue?vue&type=template&id=91355ef6"
import script from "./Choices.vue?vue&type=script&lang=js"
export * from "./Choices.vue?vue&type=script&lang=js"
import style0 from "./Choices.vue?vue&type=style&index=0&id=91355ef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports